export class PersonIngestionApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Stages a person data file in Postgres for further processing.
     * @returns any
     * @throws ApiError
     */
    stageDataFile({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/person-ingestion/stage',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Generates a report for match evaluation.
     * @returns any
     * @throws ApiError
     */
    generateMatchEvaluationReport({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/person-ingestion/report/match-evaluation',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Generates a report of field differences.
     * @returns any
     * @throws ApiError
     */
    generateFieldDifferenceReport({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/person-ingestion/report/field-difference',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Starts the person ingestion workflow.
     * @returns PersonIngestionJobResponse
     * @throws ApiError
     */
    start({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/person-ingestion/start',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
